import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TranslatedText from "./TranslatedText";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "../Styles/AccordionHome.css";

export default function SimpleAccordion() {
  return (
    <div className="accordion-home">
      <Typography
        variant="h3"
        sx={{
          fontSize: 32,
          fontWeight: 400,
          textAlign: "center",
          color: "#2875B0",
          "@media screen and (max-width: 690px)": { fontSize: "25px" },
        }}
        gutterBottom
      >
        <TranslatedText defaultText="Більш детально читайте тут"></TranslatedText>
        <br></br>
        <ArrowDownwardIcon style={{ color: "#2875B0" }} />
      </Typography>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{
            background: "#eee",
          }}
        >
          <h3 className="input-heading">
            <TranslatedText defaultText="Поїздка в зоопарк міста Крістіансанн" />
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <Typography
            className="input-text"
            variant="h5"
            fontSize={16}
            fontWeight={100}
          >
            <TranslatedText
              defaultText="
Група людей з Фокус Ларвік та громади організувала поїздку до зоопарку у Крістіансанді цього літа. Вони взяли з собою 48 українських біженців, які насолоджувалися мандрівкою та зустріли багато цікавих тварин, що викликали усмішки та радість."
            />
          </Typography>
          <a
            className="contact-a"
            href="https://www.op.no/48-ukrainske-flyktninger-dyreparken-ga-oss-en-deilig-folelse-av-a-vare-hjemme/s/5-36-1261688"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {
              <h2
                className="box-link"
                style={{ fontSize: "20px", fontWeight: "400" }}
              >
                <TranslatedText defaultText="Перейти до джерела" />

                <ArrowForwardIcon />
              </h2>
            }
          </a>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{ background: "#eee" }}
        >
          <h3 className="input-heading">
            <TranslatedText
              defaultText="
              Для української родини, яка зараз слухала виступ президента перед парламентом, було кілька вражаючих моментів"
            />
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <Typography
            className="input-text"
            variant="h5"
            fontSize={16}
            fontWeight={100}
            textAlign="center"
          >
            <TranslatedText
              defaultText="Зеленський розповів про спільну історію двох країн, згадав епоху вікінгів і Другу світову війну.

Президент підкреслив, що Норвегія та Україна мають спільного сусіда та стикаються зі спільною загрозою спільним цінностям.

З росіянами немає обмежень, вони атакують все, - сказав він.

Найзворушливішим для родини був момент, коли Зеленський згадав про святкування Дня Конституції Норвегії.

Він зазначив, що цього року в поїзді 17 травня також буде багато українських дітей."
            />
          </Typography>
        </AccordionDetails>
        <a
          className="contact-a"
          href="https://www.nrk.no/vestfoldogtelemark/zelenskyjs-tale-til-stortinget_-_-vi-fikk-tarer-i-oynene-1.15913899"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {
            <h2
              className="box-link"
              style={{ fontSize: "20px", fontWeight: "400" }}
            >
              <TranslatedText defaultText="Перейти до джерела" />

              <ArrowForwardIcon />
            </h2>
          }
        </a>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ background: "#eee" }}
        >
          <h3 className="input-heading">
            <TranslatedText defaultText="Українці разом стоять на площі" />
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <Typography
            className="input-text"
            variant="h5"
            fontSize={16}
            fontWeight={100}
            textAlign={"center"}
          >
            <TranslatedText defaultText="У п'ятницю по всій Норвегії українські біженці разом із норвежцями відзначили першу річницю війни в Україні. У Ларвіку з'явилося близько сотні людей, які пішли вулицями центру міста. Відтак відбулося виконання гімну України, хвилина мовчання в пам’ять загиблих та звернення як місцевих політиків, так і українців." />
          </Typography>
        </AccordionDetails>
        <a
          className="contact-a"
          href="https://www.larvik.kommune.no/kultur-idrett-og-frivillighet/aktuelt/maria-35-talte-paa-torget-leiligheten-vaar-er-bombet-to-ganger/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {
            <h2
              className="box-link"
              style={{ fontSize: "20px", fontWeight: "400" }}
            >
              <TranslatedText defaultText="Перейти до джерела" />

              <ArrowForwardIcon />
            </h2>
          }
        </a>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{ background: "#eee" }}
        >
          <h3 className="input-heading">
            <TranslatedText defaultText="Збірка новин про українських біженців в Норвегії від NRK.no" />
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <Typography
            className="input-text"
            variant="h5"
            fontSize={16}
            fontWeight={100}
          >
            <TranslatedText
              defaultText="РЕЗЮМЕ
Близько 40 тисяч українців приїхали до Норвегії як біженці після нападу Росії на їхню батьківщину"
            />
          </Typography>
        </AccordionDetails>
        <a
          className="contact-a"
          href="https://www.nrk.no/nyheter/flyktninger-fra-ukraina-1.15912060"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {
            <h2
              className="box-link"
              style={{ fontSize: "20px", fontWeight: "400" }}
            >
              <TranslatedText defaultText="Перейти до джерела" />

              <ArrowForwardIcon />
            </h2>
          }
        </a>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{ background: "#eee" }}
        >
          <h3 className="input-heading">
            <TranslatedText defaultText="Збірка новин про українських біженців в Норвегії від vg.no" />
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <Typography
            className="input-text"
            variant="h5"
            fontSize={16}
            fontWeight={100}
          >
            <TranslatedText
              defaultText="Це сталося:
У спеціальному випуску «Україна» від VG ви знайдете узагальнені останні новини, карти фронтів та жорстокі відеодокази."
            />
          </Typography>
        </AccordionDetails>
        <a
          className="contact-a"
          href="https://direkte.vg.no/krig-i-ukraina/news"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {
            <h2
              className="box-link"
              style={{ fontSize: "20px", fontWeight: "400" }}
            >
              <TranslatedText defaultText="Перейти до джерела" />

              <ArrowForwardIcon />
            </h2>
          }
        </a>
      </Accordion>
    </div>
  );
}
